import React from 'react';

import PropTypes from 'prop-types';
import { RadioGroup } from '@telus-uds/components-web';

import Label from './common/label';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';

const DefectPriority = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  const {
    reportAnIssue: {
      form: {
        labelPriority,
        labelPriorityOptionLow,
        labelPriorityOptionMedium,
        labelPriorityOptionHigh,
        labelPriorityOptionUrgent
      }
    }
  } = useLocalizedStringsContext();

  const fieldError = 'priority' in formErrors;
  const fieldOptions = [
    labelPriorityOptionLow,
    labelPriorityOptionMedium,
    labelPriorityOptionHigh,
    labelPriorityOptionUrgent
  ];

  const handleSelect = (value) => {
    if (value)
      setFormErrors(previousValue => {
        const updatedValues = { ...previousValue };
        delete updatedValues.priority;
        return updatedValues;
      });
    setFieldData(previousValue => ({
      ...previousValue,
      priority: value
    }));
  };

  // Convert options to RadioGroup items format
  const radioItems = fieldOptions.map(option => ({
    label: option,
    id: option
  }));

  return (
    <div>
      <Label labelName={`${labelPriority} *`} />
      <RadioGroup
        items={radioItems}
        checkedId={fieldData.priority || null}
        onChange={handleSelect}
        name="priority"
        validation={fieldError ? 'error' : undefined}
        feedback={fieldError ? formErrors.priority.message : undefined}
      />
    </div>
  );
};

DefectPriority.propTypes = {
  formErrors: PropTypes.shape({
    priority: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    defectWebform: PropTypes.string,
    defectCategory: PropTypes.string,
    priority: PropTypes.string,
    issueSummary: PropTypes.string,
    errorMessage: PropTypes.string,
    stepsToReplicate: PropTypes.string,
    attachment: PropTypes.string
  }).isRequired
};

export default DefectPriority;
